import trainingStatsReducer from './reducers';

export { default as trainingStatsActions } from './actions';
export { default as trainingStatsSelectors } from './selectors';

export default trainingStatsReducer;
